import PartnersCarousel from './PartnersCarousel'

export default function ClinicasParceirasSection() {
    return (
        <section className="py-24 bg-gray-50 overflow-hidden">
            <style>{`
                .typewriter-wrapper {
                    display: inline-block;
                }
                .typewriter-effect {
                    overflow: hidden;
                    white-space: nowrap;
                    border-right: 6px solid #16a34a; /* green-600 */
                    width: 0;
                    margin: 0 auto;
                    animation: typing 1.5s steps(10, end) 0.5s forwards, blink 1s step-end infinite;
                }
                @keyframes typing {
                    from { width: 0; }
                    to { width: 100%; }
                }
                @keyframes blink {
                    from, to { border-color: transparent }
                    50% { border-color: #16a34a; }
                }
            `}</style>

            <div className="container mx-auto px-4 text-center">
                <div className="flex flex-col items-center justify-center mb-10">
                    {/* Linha 1: Typewriter +2000 */}
                    <div className="typewriter-wrapper mb-6">
                        <h2 className="text-7xl md:text-9xl font-bold text-green-600 tracking-tighter typewriter-effect pr-2">
                            +2000
                        </h2>
                    </div>

                    {/* Linha 2: Placa em Destaque */}
                    <div className="relative mt-2 group cursor-default">
                        {/* Shadow layer rotated */}
                        <div className="absolute inset-0 bg-green-200 rounded-2xl transform rotate-3 transition-transform duration-300 group-hover:rotate-6 shadow-xl"></div>
                        {/* Main placard block */}
                        <div className="relative bg-white border-4 border-green-500 px-8 py-4 md:px-12 md:py-6 rounded-2xl shadow-2xl transform -rotate-2 transition-transform duration-300 group-hover:-rotate-3 flex items-center justify-center">
                            <span className="text-3xl md:text-6xl font-bold uppercase tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-800">
                                Clínicas Parceiras
                            </span>
                        </div>
                    </div>
                </div>

                <p className="text-xl md:text-2xl text-gray-600 mb-16 max-w-4xl mx-auto font-medium leading-relaxed">
                    Presentes em todo o território nacional, garantindo atendimento de excelência e rapidez onde a sua equipe precisar.
                </p>
                <PartnersCarousel />
            </div>
        </section>
    )
}
